import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const COLOURS = [
  { name: "Green", swatch: "bg-emerald-600", examples: "Broccoli, spinach, beans, peas, lettuce, zucchini, avocado", use: "Sides, stir-fries, salads, omelettes, wraps." },
  { name: "Red", swatch: "bg-red-600", examples: "Tomato, capsicum, strawberries, watermelon", use: "Salads, salsa, pasta, yoghurt bowls." },
  { name: "Orange / Yellow", swatch: "bg-orange-500", examples: "Carrot, pumpkin, sweet potato, corn, oranges, mango", use: "Roast trays, soups, breakfast fruit, bowls." },
  { name: "Blue / Purple", swatch: "bg-purple-600", examples: "Blueberries, blackberries, grapes, beetroot, purple cabbage", use: "Yoghurt, oats, salads, slaw." },
  { name: "White / Brown", swatch: "bg-stone-500", examples: "Mushrooms, cauliflower, onion, garlic, potato, banana", use: "Omelettes, tray bakes, mash, stir-fries, smoothies." },
];

const YOGHURT = [
  "Greek yoghurt + berries + oats",
  "Greek yoghurt + dragon fruit + berries",
  "Greek yoghurt + banana + cinnamon + walnuts",
  "Greek yoghurt + mango + chia",
  "Greek yoghurt + kiwi + strawberries",
  "Greek yoghurt + apple + cinnamon + oats",
  "Greek yoghurt + pineapple + small amount of coconut",
  "Greek yoghurt + peach or nectarine + pumpkin seeds",
  "Greek yoghurt + grapes + mixed nuts",
  "Greek yoghurt + pear + berries + chia",
];

export default function EatProduce() {
  return (
    <div className="space-y-8" data-testid="eat-produce-page">
      <div>
        <Link to="/app/eat" className="text-xs uppercase tracking-widest text-muted-foreground inline-flex items-center gap-1 hover:text-primary">
          <ChevronLeft size={14} /> Eat
        </Link>
        <div className="label-eyebrow mt-3">Fruit + Veg</div>
        <h1 className="wordmark mt-2 text-4xl md:text-5xl uppercase">Colour On The Plate.</h1>
        <p className="mt-2 text-muted-foreground max-w-xl">A simple colour-based rotation. Aim for two or more colours at lunch and dinner where practical.</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        {COLOURS.map((c) => (
          <div key={c.name} className="bg-card border border-border rounded-lg p-5" data-testid={`produce-${c.name.toLowerCase().replace(/[^a-z]/g, "")}`}>
            <div className="flex items-center gap-2">
              <span className={`inline-block w-4 h-4 rounded-md ${c.swatch}`} />
              <div className="font-head uppercase text-lg">{c.name}</div>
            </div>
            <div className="mt-4 text-[10px] uppercase tracking-widest text-muted-foreground">Examples</div>
            <p className="mt-1 text-sm">{c.examples}</p>
            <div className="mt-3 text-[10px] uppercase tracking-widest text-muted-foreground">Use</div>
            <p className="mt-1 text-sm text-foreground/80">{c.use}</p>
          </div>
        ))}
      </div>

      <div className="bg-foreground text-background rounded-lg p-8">
        <div className="label-eyebrow !text-background/70">Fruit + Yoghurt Ideas</div>
        <h2 className="wordmark mt-3 text-3xl uppercase">Ten easy combinations.</h2>
        <p className="mt-2 text-sm text-background/80 max-w-xl">Fast breakfast, snack or dessert. Greek yoghurt is the protein anchor.</p>
        <ul className="mt-6 grid md:grid-cols-2 gap-2">
          {YOGHURT.map((y, i) => (
            <li key={y} className="flex gap-3 text-sm text-background/90">
              <span className="wordmark text-primary w-8 shrink-0 text-lg leading-tight">{String(i + 1).padStart(2, "0")}</span>
              <span>{y}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
